import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAdminStore } from '../store/AdminStore'

const OrgProtected = () => {
  const orgId = useAdminStore((state) => state.orgId)

  if (!orgId) {
    return <Navigate to="/admin" replace />
  }

  return <Outlet />
}

export default OrgProtected
